import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type {
  GetOffersPurchasesResponse,
  GetOffersSalesResponse,
  GetOffersSubscriptionsResponse,
  GetOffersTrialUnsubscriptionsResponse,
  GetOffersTrialUnsubscriptionsViewsResponse,
  GetOfferUnsubscriptionsGroupByOfferResponse,
  GetOfferUnsubscriptionsResponse,
  GetUnsubscribeReasonsResponse,
} from "@/src/api/StatsAPI.types";

import type { OfferAnalyticsFilterValues } from "./offerAnalytics.types";

// Shared so identical params hit one cache entry; filtered queries keep the previous period while refetching.

export function offersSalesQuery(
  projectSlug: string,
): Query<GetOffersSalesResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOffersSales,
    params: [{ projectSlug }],
  });
}

export function offersSubscriptionsQuery(
  projectSlug: string,
  { startDate, endDate, offerUuid }: OfferAnalyticsFilterValues,
): Query<GetOffersSubscriptionsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOffersSubscriptions,
    params: [{ projectSlug, startDate, endDate, offerUuid }],
    options: { keepPreviousData: true },
  });
}

export function offersPurchasesQuery(
  projectSlug: string,
  { startDate, endDate }: OfferAnalyticsFilterValues,
): Query<GetOffersPurchasesResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOffersPurchases,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function offerUnsubscriptionsQuery(
  projectSlug: string,
  { startDate, endDate }: OfferAnalyticsFilterValues,
): Query<GetOfferUnsubscriptionsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOfferUnsubscriptions,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function offerUnsubscriptionsGroupByOfferQuery(
  projectSlug: string,
  { startDate, endDate, offerUuid }: OfferAnalyticsFilterValues,
): Query<GetOfferUnsubscriptionsGroupByOfferResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOfferUnsubscriptionsGroupByOffer,
    params: [{ projectSlug, startDate, endDate, offerUuid }],
    options: { keepPreviousData: true },
  });
}

export function unsubscribeReasonsQuery(
  projectSlug: string,
  { startDate, endDate, offerUuid }: OfferAnalyticsFilterValues,
  lang: string,
): Query<GetUnsubscribeReasonsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getUnsubscribeReasons,
    params: [{ projectSlug, startDate, endDate, lang, offerUuid }],
    options: { keepPreviousData: true },
  });
}

export function trialUnsubscriptionsViewsQuery(
  projectSlug: string,
  { startDate, endDate }: OfferAnalyticsFilterValues,
): Query<GetOffersTrialUnsubscriptionsViewsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOffersTrialUnsubscriptionsViews,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function trialUnsubscriptionsQuery(
  projectSlug: string,
  { startDate, endDate }: OfferAnalyticsFilterValues,
): Query<GetOffersTrialUnsubscriptionsResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getOffersTrialUnsubscriptions,
    params: [{ projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}
